"use client";

import { useState } from "react";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const products = [
  {
    id: 1,
    name: "Ponceuse à bande légère Diablo",
    seller: "TOOLOUER",
    price: "29,00 €",
    image: "/products/product1.jpeg",
  },
  {
    id: 2,
    name: "Pompe de désembouage - 5 m³/h",
    seller: "TOOLOUER",
    price: "51,00 €",
    image: "/products/product2.jpeg",
  },
  {
    id: 3,
    name: "Fraiseuse sol pvc",
    seller: "TOOLOUER",
    price: "16,80 €",
    image: "/products/compresseur.webp",
  },
  {
    id: 4,
    name: "Compresseur thermique d'air 1200 l min",
    seller: "TOOLOUER",
    price: "24,90 €",
    image: "/products/tronconneuse.webp",
  },
  {
    id: 5,
    name: "Tronçonneuse à chaîne essence 2 temps-guide 400",
    seller: "TOOLOUER",
    price: "18,00 €",
    image: "/products/tronconneuse-essence.webp",
  },
];

type Tab = "location" | "achat";

export function NewProductsSection() {
  const [activeTab, setActiveTab] = useState<Tab>("location");

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <h2 className="text-2xl font-bold flex items-center gap-3">
            <Image src="/logo-vignette.png" alt="" width={32} height={32} className="h-8 w-8" />
            Les nouveautés
          </h2>

          <div className="flex items-center gap-3">
            {/* Tabs */}
            <div className="flex gap-2">
              <button
                onClick={() => setActiveTab("location")}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
                  activeTab === "location"
                    ? "bg-secondary text-white"
                    : "bg-white text-secondary border-2 border-secondary hover:bg-secondary/10"
                }`}
              >
                Location
              </button>
              <button
                onClick={() => setActiveTab("achat")}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
                  activeTab === "achat"
                    ? "bg-secondary text-white"
                    : "bg-white text-secondary border-2 border-secondary hover:bg-secondary/10"
                }`}
              >
                Achat
              </button>
            </div>

            {/* Nav arrows */}
            <div className="flex gap-1">
              <Button variant="outline" size="icon" className="h-10 w-10 rounded-full">
                <ChevronLeft className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="icon" className="h-10 w-10 rounded-full bg-secondary text-white hover:bg-secondary/90 border-0">
                <ChevronRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl border hover:shadow-lg transition-shadow cursor-pointer group overflow-hidden"
            >
              <div className="aspect-square relative bg-white p-4">
                <Image
                  src={product.image}
                  alt={product.name}
                  fill
                  className="object-contain p-2"
                />
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm mb-1 line-clamp-2 group-hover:text-secondary transition-colors min-h-[2.5rem]">
                  {product.name}
                </h3>
                <p className="text-xs text-muted-foreground mb-2">
                  {product.seller}
                </p>
                <div className="flex items-baseline gap-1 mb-3">
                  <span className="text-xl font-bold">{product.price}</span>
                  <span className="text-sm text-muted-foreground">
                    HT/ jour
                  </span>
                </div>
                <Button size="sm" className="w-full bg-secondary hover:bg-secondary/90 text-white">
                  Réserver ma location
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
